import { Expose, Type } from "class-transformer";

export class MasterMaterialModel {
  constructor() {
    this.matId = 0;
    this.matType = "";
    this.code = "";
    this.name = "";
    this.image = "";
    this.price = 0;
    this.unit = "";
    this.requestAmount = 0;
    this.actualAmount = 0;
    this.actualPrice = 0;
  }

  @Expose({ name: "matId" })
  matId: number;

  @Expose({ name: "matType" })
  matType: string;

  @Expose({ name: "code" })
  code: string;

  @Expose({ name: "name" })
  name: string;

  @Expose({ name: "image" })
  image?: string;

  @Expose({ name: "price" })
  price?: number;

  @Expose({name: "unitName"})
  unit?: string;

  @Expose({ name: "requestAmount" })
  requestAmount: number;

  @Expose({ name: "actualAmount" })
  actualAmount: number;

  @Expose({ name: "actualPrice" })
  actualPrice?: number;

  @Expose({ name: "adjustAmount" })
  adjustAmount?: number;

  @Expose({ name: "packages" })
  @Type(() => MasterMaterialModel)
  packages?: MasterMaterialModel[];

  public isPackage(): boolean {
    return this.packages != null && this.packages.length > 0;
  }
}
